export default __webpack_public_path__ + "static/locationsHero-0136f5544934ca6bda103675ada3b57d.svg";